module.exports = __webpack_public_path__ + "img/402.bece4ea5.png";